<template>
  <el-dialog :title="title" :visible="visible" width="700px" @close="close">
    <pre class="json-dialog-content">{{ formattedContent }}</pre>
    <div slot="footer">
      <el-button @click="close">关闭</el-button>
      <el-button type="primary" @click="copy">复制</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'JsonViewerDialog',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: 'JSON 内容' },
    value: { default: '' }
  },
  computed: {
    formattedContent () {
      const rawValue = this.value === null || this.value === undefined || this.value === '' ? '-' : this.value
      try {
        const parsed = typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue
        return JSON.stringify(parsed, null, 2) || String(rawValue)
      } catch (e) {
        return String(rawValue)
      }
    }
  },
  methods: {
    close () {
      this.$emit('update:visible', false)
    },
    copy () {
      this.$copyText(this.formattedContent).then(() => {
        this.$message.success('已复制')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.json-dialog-content {
  max-height: 60vh;
  margin: 0;
  overflow: auto;
  padding: 12px;
  border-radius: 4px;
  background: #f5f7fa;
  color: #303133;
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
